import React from 'react'
import './PaymentPriceCard.css'
import { TbCheck } from 'react-icons/tb'
import { useLanguage } from '../../../../LanguageProvider';

export default function PaymentPriceCard({ title, price, specs, onClick }) {
    const { getTranslation } = useLanguage();
    return (
        <div onClick={onClick} className='payment-pricecard-container'>
            <span className='payment-pricecard-title'>{title}</span>
            <span className='payment-pricecard-price'>{price}<span className='payment-pricecard-month'>/{getTranslation("month")}</span></span>
            <span className='payment-pricecard-specs-holder'>
                {specs.map(spec => (
                    <span className='payment-pricecard-spec'>
                        <span className='payment-price-card-check-holder'>
                            <TbCheck color='var(--idea-card-footer-bg)' size={12} strokeWidth={4}  />
                        </span>
                        {spec}</span>
                ))}
            </span>

        </div>
    )
}
